import { createAction } from 'redux-actions';

export var types = {
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR'
};

export var show = createAction(types.SHOW_SNACKBAR);
export var hideSnackbar = createAction(types.HIDE_SNACKBAR);

var timeout = 0;

var payloadIsValid = function payloadIsValid(payload) {
  /* we dont want to show an empty message */
  if (!payload.message || !payload.message.length) {
    return false;
  }

  /* payload status should be null or one of these strings */
  if (payload.status && ['success', 'error', 'default'].indexOf(payload.status) === -1) {
    return false;
  }

  return true;
};

export var showSnackbar = function showSnackbar() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  return function (dispatch, getState) {
    if (payload.message && payload.message.toString) {
      payload.message = payload.message.toString();
    } else {
      payload.message = 'default';
    }

    if (!payloadIsValid(payload)) {
      console.warn('gipsy-ui/src/Snackbar/actions.js : payload is invalid', payload);
      return;
    }

    dispatch(show(payload));
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function () {
      dispatch(hideSnackbar());
    }, duration);
  };
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Snackbar/actions.js
// module id = 300
// module chunks = 0